import axios, { AxiosResponse } from "axios";
import { call, put, takeLatest } from "redux-saga/effects";
import { API_BASE_ADDRESS } from "../../API";
import { fetchAdminCompanyListFailure, fetchAdminCompanyListSuccess } from "../../actions/adminCompanyListActions/adminCompanyListActions";
import { adminCompanyListTypes } from "../../ActionTypes/adminCompanyListTypes";

const getAdminCompanyList = (data: any) => { 
  const config = {
    headers: { 
      Prefer: 'example=example-1', Accept: 'application/json', 
      Authorization: localStorage.jobParachannelAuthAdminToken 
    }
  };
  return axios.get(API_BASE_ADDRESS + '/admin/companies?page=' + data.page + '&keyword=' + data.keyword +'&per=' + 50, config); 
}


function* fetchAdminCompanyListSaga(action: any) {
  try {
    const response: AxiosResponse = yield call(getAdminCompanyList, action.data);
    yield put(
      fetchAdminCompanyListSuccess({
        companies: response.data.companies,
        pagenation: response.data.pagenation,
      })
    );
  } catch (e:any) {
    yield put(
      fetchAdminCompanyListFailure({
        error: e.message
      })
    );
  }
}

function* AdminCompanyListSaga() {
  yield takeLatest(adminCompanyListTypes.FETCH_ADMIN_COMPANY_LIST_REQUEST, fetchAdminCompanyListSaga);
}
export default AdminCompanyListSaga;